import IconRocket2 from "./icon-rocket-2";

export default IconRocket2